<p-confirmdialog></p-confirmdialog>

<div class="composicao-container">
    @if (carregamentoInicialSemDados()) {
        <div class="flex justify-center items-center py-8 min-h-[160px]">
            <p-progressSpinner ariaLabel="Carregando composição"></p-progressSpinner>
        </div>
    }

    <app-card-content icon="pi pi-users" title="Composição do Órgão">
        <div card-header>
            <div class="acao-adicionar-membro">
                @if (temPermissaoEdicao()) {
                    <p-button
                        label="Adicionar Membro"
                        icon="pi pi-plus-circle"
                        (onClick)="abrirCadastro()"
                        [text]="false"
                        [rounded]="false"
                        [style]="{ 'white-space': 'nowrap' }"
                        [appCan]="PERMISSOES.orgaos.composicao.criar"
                        [appCanUf]="uf()"
                    ></p-button>
                }
            </div>
        </div>

        <div class="flex justify-center mb-4 controle-tipo-composicao">
            <p-selectbutton
                [options]="opcoesTipoComposicao"
                [ngModel]="visualizandoAntigos()"
                (ngModelChange)="onTipoComposicaoChange($event)"
                optionLabel="label"
                optionValue="value"
                [unselectable]="false"
                class="flex flex-wrap justify-center gap-2"
                styleClass="w-36"
            >
            </p-selectbutton>
        </div>

        <app-custom-table [data]="composicoes()" [metadata]="metadata" [showActions]="true" [loading]="carregando()" [columnOrder]="ordemColunas" [showExpandButton]="false" [rows]="10" [totalRecords]="composicoes().length" [permissaoUf]="uf()">
        </app-custom-table>
    </app-card-content>
</div>

<p-dialog appDialogoPadrao="pi pi-users" descricao="Membro da composição do órgão." [header]="tituloDialogComposicao" [visible]="exibirDialogEdicao()" (visibleChange)="exibirDialogEdicao.set($event)" [style]="{ width: '760px', maxWidth: '95vw' }">
    <form [formGroup]="formularioEdicao" class="grid grid-cols-1 md:grid-cols-2 gap-4 pt-2">
        @if (modoCadastro()) {
            <div class="flex flex-col gap-1.5">
                <label for="crmMembro" class="font-semibold">CRM *</label>
                <input id="crmMembro" pInputText formControlName="crm" type="number" min="1" class="w-full" />
            </div>
        }

        <div class="flex flex-col gap-1.5">
            <label for="ufMembro" class="font-semibold">UF *</label>
            <input id="ufMembro" pInputText formControlName="uf" class="w-full" readonly />
        </div>

        <div class="flex flex-col gap-1.5">
            <label for="cargoMembro" class="font-semibold">Cargo *</label>
            <p-select id="cargoMembro" [options]="cargos" formControlName="cargo" optionLabel="label" optionValue="value" placeholder="Selecione o cargo" class="w-full" appendTo="body"> </p-select>
        </div>

        @if (!modoCadastro()) {
            <div class="md:col-span-2 flex flex-col gap-1.5">
                <label for="nomeMembro" class="font-semibold">Nome *</label>
                <input id="nomeMembro" pInputText formControlName="nome" class="w-full" readonly />
            </div>
        }

        <div class="flex flex-col gap-1.5">
            <label for="dataEntradaMembro" class="font-semibold">Data de Entrada *</label>
            <p-date-picker inputId="dataEntradaMembro" formControlName="dataEntrada" dateFormat="dd/mm/yy" [showIcon]="true" [appendTo]="'body'" [showClear]="false" fluid class="w-full" placeholder="dd/mm/aaaa"> </p-date-picker>
        </div>

        <div class="flex flex-col gap-1.5">
            <label for="dataSaidaMembro" class="font-semibold">Data de Saída</label>
            <p-date-picker inputId="dataSaidaMembro" formControlName="dataSaida" dateFormat="dd/mm/yy" [showIcon]="true" [appendTo]="'body'" [showClear]="true" fluid class="w-full" placeholder="dd/mm/aaaa"> </p-date-picker>
            <small class="text-slate-500 italic">Deixe em branco se o membro ainda estiver ativo.</small>
        </div>
    </form>

    <ng-template pTemplate="footer">
        <div class="flex justify-end gap-3 pt-2">
            <p-button label="Cancelar" icon="pi pi-times" [text]="true" (onClick)="exibirDialogEdicao.set(false)"></p-button>
            <p-button [label]="labelBotaoSalvar" icon="pi pi-check" [loading]="salvandoEdicao()" (onClick)="salvarEdicao()"></p-button>
        </div>
    </ng-template>
</p-dialog>
